import React, { useContext } from 'react'
import Modal from '../components/Modal'
import { ContentStackTypes, ModalTypes, UserOs } from '../store/Constants'
import { ANALYTICS } from '../analytics'
import classes from './TroubleInstallingModal.module.scss'
import { ConfigContext } from '../store/ConfigContext'
import { Paths } from '../store/Constants'

const TroubleInstallingModal = ({
  open,
  onClose,
  showFooter,
  parentScreen
}) => {
  const { isMobile, os, currentPath, flowActions } = useContext(ConfigContext)
  const getContentType = () => {
    if (isMobile) {
      return ContentStackTypes.trouble_installing_modal_mobile
    }
    return os === UserOs.mac
      ? ContentStackTypes.trouble_installing_modal_desktop_mac
      : ContentStackTypes.trouble_installing_modal_desktop_win
  }

  const inferredParentScreenByPath = {
    [Paths.device_not_listed]:
      ANALYTICS.SCREENS.DEVICE_NOT_LISTED_INSTALL_HP_APP,
    [Paths.hp_app]: ANALYTICS.SCREENS.INSTALL_HP_APP,
    [Paths.usb_only]: ANALYTICS.SCREENS.USB_INSTALL_HP_APP,
    [Paths.paas]: ANALYTICS.SCREENS.ALL_IN_PLAN_WELCOME,
    [Paths.basicDriver]: ANALYTICS.SCREENS.INSTALL_DRIVERS
  }[currentPath]

  const inferredParentScreenByPageId = {
    'device-not-listed': ANALYTICS.SCREENS.DEVICE_NOT_LISTED_INSTALL_HP_APP,
    'install-hp-app': ANALYTICS.SCREENS.INSTALL_HP_APP,
    'usb-only': ANALYTICS.SCREENS.USB_INSTALL_HP_APP,
    paas: ANALYTICS.SCREENS.ALL_IN_PLAN_WELCOME,
    'basic-driver-landing-page': ANALYTICS.SCREENS.INSTALL_DRIVERS,
    'get-software': ANALYTICS.SCREENS.INSTALL_HP_EASY_START_GENERIC,
    'easy-start': ANALYTICS.SCREENS.INSTALL_HP_EASY_START,
    laserjet: ANALYTICS.SCREENS.LASERJET_INSTALL_HP_APP
  }[flowActions?.currentFlow?.page_id]

  const inferredParentScreen =
    inferredParentScreenByPageId || inferredParentScreenByPath

  const modalScreen = {
    ...ANALYTICS.MODALS.TROUBLE_INSTALLING,
    screenPath: parentScreen
      ? `${parentScreen.screenPath}${parentScreen.screenName}/`
      : inferredParentScreen
      ? `${inferredParentScreen.screenPath}${inferredParentScreen.screenName}/`
      : ANALYTICS.MODALS.TROUBLE_INSTALLING.screenPath
  }

  if (!open) return null

  return (
    <Modal
      className={classes.troubleInstallingModalContainer}
      show={open}
      contentType={getContentType()}
      primaryClick={isMobile ? null : onClose}
      onClose={onClose}
      closeButton={true}
      showFooter={showFooter}
      analytics={{
        screen: modalScreen,
        primary_button: ANALYTICS.BUTTONS.CLOSE,
        close_button: ANALYTICS.BUTTONS.CLOSE_MODAL
      }}
      type={ModalTypes.trouble_installing}
    >
      {({ pageData }) =>
        pageData.map(({ data }, i) => (
          <div key={i} dangerouslySetInnerHTML={{ __html: data }} />
        ))
      }
    </Modal>
  )
}

export default TroubleInstallingModal
